import _ from 'lodash';
import { formatNumWithKMBAlt } from 'utils/helperMethods';

export function portfolioAnalysisV2Parser(data: any[], config: any, kpiConfig: any[]) {
    const { decimalForPercentage, decimalForNonPercentage } = config;

    try {
        let result: any[] = [];
        data?.map((item: any) => {
            const tempObj: any = {};
            let key = '';
            item?.selected_fields_data?.forEach((attr: any) => {
                tempObj[attr['name']] = attr['value'];
                key += attr['value'];
            });
            tempObj['key'] = key;
            item?.kpis_data?.forEach((kpi: any) => {
                const isPercentageField = kpiConfig.find((k) => k.value === kpi['kpi_id'])?.post === '%';
                tempObj[kpi['kpi_id']] = {
                    value: _.isNil(kpi?.value)
                        ? kpi?.value
                        : formatNumWithKMBAlt(
                              kpi?.value,
                              isPercentageField ? decimalForPercentage : decimalForNonPercentage,
                          ),
                    unFormattedValue: kpi?.value,
                    color: kpi?.kpi_color
                        ? `rgb(${kpi?.kpi_color?.R},${kpi?.kpi_color?.G},${kpi?.kpi_color?.B})`
                        : undefined,
                };
            });
            result.push(tempObj);
        });
        return result;
    } catch (error) {
        throw error;
    }
}
